import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive
} from '@angular/router';
import {NgClass} from '@angular/common';
import {LeftNavbarService} from '../../../services/left-navbar/left-navbar.service';
import {VersionService} from '../../../services/version/version.service';
import {IsGrantedDirective} from '../../../directives/is-granted/is-granted.directive';
import {IsAnyGrantedDirective} from '../../../directives/is-granted/is-any-granted.directive';

@Component({
  selector: 'app-left-navbar',
  imports: [
    RouterLinkActive,
    RouterLink,
    NgClass,
    IsGrantedDirective,
    IsAnyGrantedDirective,
  ],
  templateUrl: './left-navbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './left-navbar.component.scss'
})
export class LeftNavbarComponent implements OnInit, AfterViewInit, OnDestroy {

  private url: string | null = null;
  private mutationObserver: MutationObserver | null = null;

  constructor(
    protected leftNavbarService: LeftNavbarService,
    private router: Router,
    private versionService: VersionService,
    private elementRef: ElementRef<HTMLElement>
  ) {
  }

  getActiveMenuClass(route: string): string {
    return this.url?.startsWith(route) ? 'active' : '';
  }

  ngOnInit(): void {
    this.router.events.subscribe((data) => {
      if (data instanceof NavigationEnd) {
        this.url = data.url;
        this.openActiveSubmenu();
      }
    });
  }

  ngAfterViewInit(): void {
    this.openActiveSubmenu();
    this.mutationObserver = new MutationObserver(() => this.openActiveSubmenu());
    this.mutationObserver.observe(this.elementRef.nativeElement, {
      childList: true,
      subtree: true
    });
  }

  ngOnDestroy(): void {
    this.mutationObserver?.disconnect();
  }

  getVersion(): string {
    return this.versionService.getFullVersion();
  }

  private openActiveSubmenu(): void {
    setTimeout(() => {
      const collapses = this.elementRef.nativeElement.querySelectorAll<HTMLElement>('.collapse');
      collapses.forEach((collapse) => {
        if (collapse.querySelector('.nav-link.active') && !collapse.classList.contains('show')) {
          collapse.classList.add('show');
        }
      });
    });
  }
}
